/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from "@angular/core";
import {BaseService} from "./base-service";
import { HttpHeaders } from '@angular/common/http';
import {Router} from "@angular/router";
import {AuthenticationService} from "./authentication.service";
import {LocationInstance} from "../models/location-instance";
import {ObjectInstance} from "../models/object-instance";
import {User} from "../models/user";
import {HistoryData} from "../models/history-data";
import { RestService } from "./rest-service";
import { Url_Base } from "app/rest-constants";

@Injectable()
export class HistoryService extends BaseService {

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private restService: RestService
  ) { super(router, authenticationService); }

  getUrl(): string {
    return `${Url_Base}/history`;
  }

  getHistoryMovement(dateFrom: string, dateTo: string, locations: LocationInstance[], assets: ObjectInstance[], people: ObjectInstance[]): Promise<HistoryData> {
    // The Google browser puts a 'T' in between the time and date, we need to replace this with a space for the web service call
    if (dateFrom == null) {
      return Promise.reject(null);
    }
    if (dateTo == null) {
      return Promise.reject(null);
    }

    // Remove all T and commas (these appear between date and time. API doesn't want them)
    dateFrom = dateFrom.replace("T", " ");
    dateTo = dateTo.replace("T", " ");

    dateFrom = dateFrom.replace("\,", " ");
    dateTo = dateTo.replace("\,", " ");

    // Add seconds to the end of the dates (API needs this, but the GUI doesn't allow it to be changed)
    dateFrom += ":00";
    dateTo += ":00";


    // create a location array of just ids
    const locationIdsArray = [];
    if (locations != null && locations.length > 0) {
      for (const location of locations) {
        locationIdsArray.push(location.id);
      }
    }

    // create an assets array of just ids
    const assetIdsArray = [];
    if (assets != null && assets.length > 0) {
      for (const asset of assets) {
        assetIdsArray.push(asset.id);
      }
    }

    // create a user array of just ids
    const personIdsArray = [];
    if (people != null && people.length > 0) {
      for (const person of people) {
        personIdsArray.push(person.id);
      }
    }

    //KHT 09/01/2021 - added start and stop to body as dates for new API Endpoint
    const body = { locationIds: locationIdsArray, assetIds: assetIdsArray, peopleIds: personIdsArray, start: new Date(dateFrom), stop: new Date(dateTo) };
    const bodyJson = JSON.stringify(body);
    console.log("historyMovement bodyJson: " + bodyJson);

    const callUrl = this.getUrl() + "/movement/" + dateFrom + "/" + dateTo + "?use_new=true";

    return this.restService.post<HistoryData>(callUrl, body);
  }



}
